module.exports = __webpack_public_path__ + "static/media/1022164.2c475f8e.jpg";